import { useLang } from "@/context/LanguageContext";
import { media } from "@/data/content";
import { Reveal, scrollToId } from "@/components/Reveal";
import { ArrowRight } from "@phosphor-icons/react";

export const Investment = () => {
  const { t } = useLang();
  return (
    <section id="investment" data-testid="investment" className="relative bg-[#F3EFEA] py-24 md:py-36">
      <div className="max-w-[1400px] mx-auto px-6 md:px-12">
        <div className="grid lg:grid-cols-2 gap-14 lg:gap-24 items-center">
          <Reveal className="overflow-hidden order-2 lg:order-1">
            <div className="aspect-[4/5] overflow-hidden">
              <img src={media.investment} alt="Investimento Zen Home" className="w-full h-full object-cover hover:scale-105 transition-transform duration-1000" />
            </div>
          </Reveal>

          <div className="order-1 lg:order-2">
            <Reveal>
              <p className="text-sm tracking-luxe uppercase text-[#A39B8E] mb-6">{t.investment.kicker}</p>
            </Reveal>
            <Reveal delay={0.05}>
              <h2 className="font-display font-light text-4xl sm:text-5xl lg:text-6xl leading-[1.02] tracking-tight">
                {t.investment.title}
              </h2>
            </Reveal>
            <Reveal delay={0.1}>
              <p className="mt-6 text-[#1A1A1A]/70 max-w-lg leading-relaxed">{t.investment.body}</p>
            </Reveal>

            <div className="mt-10 divide-y divide-black/10 border-y border-black/10">
              {t.investment.items.map((it, i) => (
                <Reveal key={i} delay={0.1 + i * 0.07} className="py-6 flex gap-6 items-baseline group">
                  <span className="font-display text-xl text-[#8B7355] w-8 shrink-0">0{i + 1}</span>
                  <div>
                    <h3 className="text-lg font-medium">{it.title}</h3>
                    <p className="mt-1 text-sm text-[#1A1A1A]/60 leading-relaxed">{it.text}</p>
                  </div>
                </Reveal>
              ))}
            </div>

            <Reveal delay={0.2}>
              <p className="mt-8 text-sm italic text-[#1A1A1A]/50">{t.investment.note}</p>
              <button
                data-testid="investment-cta"
                onClick={() => scrollToId("contact")}
                className="group mt-8 inline-flex items-center gap-2 bg-[#1A1A1A] text-[#FAFAF7] px-8 py-4 text-sm hover:bg-[#8B7355] transition-colors duration-300"
              >
                {t.nav.cta}
                <ArrowRight size={16} className="transition-transform duration-300 group-hover:translate-x-1" />
              </button>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
};
